var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.59 1.80832C8.53417 1.80832 7.58917 2.32165 7 3.10915C6.41084 2.32165 5.46584 1.80832 4.41 1.80832C2.61917 1.80832 1.16667 3.26665 1.16667 5.06915C1.16667 5.76332 1.27751 6.40499 1.47001 6.99999C2.39167 9.91665 5.2325 11.6608 6.63834 12.1392C6.83667 12.2092 7.16334 12.2092 7.36167 12.1392C8.7675 11.6608 11.6083 9.91665 12.53 6.99999C12.7225 6.40499 12.8333 5.76332 12.8333 5.06915C12.8333 3.26665 11.3808 1.80832 9.59 1.80832Z",
    fill: "#D70D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFill);
export default __webpack_public_path__ + "static/media/heart-fill.b0f105792e9afcc3a8cad728d4052fff.svg";
export { ForwardRef as ReactComponent };